var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTitle',{attrs:{"title":_vm.$t('header.partidos_temporada', {temporada: _vm.lista_abonados.nombre})}}),_c('FirstBanner'),(_vm.eventos.length > 0)?_c('ListadoEventosClubs',{attrs:{"eventos":_vm.eventos}}):[_c('NoEvents')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }